import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { Formik, Field, Form } from "formik"
import axios from "axios"
import settings from "settings"
import { Redirect } from "react-router"
import submitData from "helpers/submitData"
import { toast } from "react-toastify"
import * as Yup from "yup"
import fieldStatus from "helpers/fieldStatus"

class ForgotPassword extends Component {
	constructor(props) {
		super(props)
		const urlParams = new URLSearchParams(window.location.search)
		this.state = {
			redirect: false,
			redirectPath: '',
			fields: {
				password: "",
				confirm_password: "",
			},
			token: urlParams.get("token"),
		}
	}

	validation = () => {
		return Yup.object().shape({
			password: Yup.string()
				.required("Please enter your new password.")
				.matches(
					/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
					"All passwords must be 8 characters and include an uppercase letter, lowercase letter, number, and a special character."
				)
				.required("Password is required."),
			confirm_password: Yup.string()
				.oneOf([Yup.ref("password"), null], "Passwords do not match.")
				.required("Password confirm is required"),
		})
	}

	_handleSubmit = (e) => {
		e.preventDefault()
		if (this.state.valid) {
			// throw up loading
			this.props.loadingStatus(true)
			//IDs of column names should match
			var qs = require("qs")
			var data = {
				email: this.state.fields[0].value,
				password: this.state.fields[1].value,
			}
			axios
				.post(settings.ep + "/login", data)
				.then((response) => {
					if (response.data.status == 200) {
						var jwtDecode = require("jwt-decode")
						var user = jwtDecode(response.data.token)
						var loginPath = ""
						if (user.aud == 1) {
							loginPath = "/entry/dashboard"
						} else {
							loginPath = "/"
						}
						localStorage.setItem("user", response.data.token)

						this.props.loadingStatus(false)
						this.props.setViewAs(0)
						this.setState({ loginValid: true, loginPath: loginPath })
					} else {
						this.props.loadingStatus(false)
						this.setState({ error: true, errorMessage: response.data.message })
					}
				})
				.catch((error) => {
					console.log(error)
				})
		} else {
			// This is where issue#1 should go

			console.log("not valid")
		}
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	render() {
		console.log(this.props)
		if (this.state.redirect) {
			return <Redirect to={this.state.redirectPath} />
		} else {
			return (
				<div className="beginReset">
					<img src={settings.logo} className="login__logo" />
					<div className="beginReset__cont">
						<Formik
							enableReinitialize
							initialValues={this.state.fields}
							validationSchema={this.validation}
							validateOnMount={true}
							onSubmit={(values) => {
								values.token = this.state.token
								submitData("resetPassword", values).then((data) => {
									toast.success(data.message)
									this.setState({ redirect: true, redirectPath: data.redirect })
								})
							}}>
							{(f) => (
								<div className="beginReset__form">
									<Form>
										{console.log(f)}
										<ul className="beginReset__list">
											<li className={fieldStatus("password", f)}>
												<label htmlFor="name">
													New Password <sup>*</sup>
												</label>
												{f.errors.password && f.touched.password && (
													<div className="form__message">{f.errors.password}</div>
												)}
												<Field name="password" type="password" className="form__input" />
											</li>
											<li className={fieldStatus("confirm_password", f)}>
												<label htmlFor="name">
													Confirm Password <sup>*</sup>
												</label>
												{f.errors.confirm_password && f.touched.confirm_password && (
													<div className="form__message">{f.errors.confirm_password}</div>
												)}
												<Field name="confirm_password" type="password" className="form__input" />
											</li>
										</ul>
										<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
									</Form>
								</div>
							)}
						</Formik>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ForgotPassword)
